<template>
  <div class="replenishment">
    <component
      :is="getComponent"
      :index="replenishmentType[current].toIndex"
      :customer-code="customerCode"
      @changeType="changeType"
    />
  </div>
</template>

<script>
import Replenishmentinfo from './components/Replenishmentinfo.vue'
import ReplenishmentIframe from './components/ReplenishmentIframe.vue'

const replenishmentType = [
  {
    toIndex: 1,
    component: Replenishmentinfo
  },
  {
    toIndex: 0,
    component: ReplenishmentIframe
  },
]

export default {
  name: 'Replenishment',
  data() {
    return {
      current: 0,
      replenishmentType,
      customerCode: ''
    }
  },
  computed: {
    getComponent() {
      const {current} = this
      return replenishmentType[current].component
    }
  },
  methods: {
    changeType(index, code = '') {
      this.current = index
      this.customerCode = code
    }
  }
}
</script>

<style scoped>
.replenishment {
  margin: 16px 24px 40px 24px;
}
</style>